import { DeepReadonly } from 'utility-types';
import { InstitutionSummary } from '../../../ReduxStorage/Institutions/types';
import { ReduxAction } from '../../../ReduxStorage/actions';

export const FETCH_PARTNERS_LISTING_PAGE_DATA_SUCCESS =
  'FETCH_PARTNERS_LISTING_PAGE_DATA_SUCCESS';

export type FetchPartnersListingPageDataSuccessAction = {
  type: 'FETCH_PARTNERS_LISTING_PAGE_DATA_SUCCESS';
  localPartners: InstitutionSummary[];
  globalPartners: InstitutionSummary[];
};

export type PartnersListingPageAction = FetchPartnersListingPageDataSuccessAction;

export type PartnersListingPageState = DeepReadonly<{
  localPartners: DeepReadonly<string[]>;
  globalPartners: DeepReadonly<string[]>;
}>;

export const INITIAL_STATE: PartnersListingPageState = {
  localPartners: [],
  globalPartners: [],
};

export const PartnersListingPageReducer = (
  state: PartnersListingPageState = INITIAL_STATE,
  action: ReduxAction
): PartnersListingPageState => {
  switch (action.type) {
    case FETCH_PARTNERS_LISTING_PAGE_DATA_SUCCESS: {
      const localPartners = action.localPartners.map((partner) => partner.path);
      const globalPartners = action.globalPartners
        .map((partner) => partner.path)
        .filter((path) => !localPartners.includes(path));

      return {
        ...state,
        localPartners,
        globalPartners,
      };
    }
    default:
      return state;
  }
};
